<template>
	<div>
		<div class="footer-border"/>
		<footer class="page-footer">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 logo-container-foot visible-xs">
						<a href="index.html">
							<img
								class="img-responsive logo-foot"
								src="@/assets/images/iadsa-logo.svg"
								alt="IADSA"
							>
						</a>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-sm-8">
						<p class="left-center-xs">
							<template v-for="page in pages">
								<router-link
									:key="page.id"
									:to="`/page/${page.id}`"
								>{{ page.title }}&nbsp;&nbsp;</router-link>
							</template>
							<a href="http://www.iadsa.org" target="_blank">iadsa.org</a>
							<br/>
							<br/>
							<small>
								© {{ currentYear }}  IADSA. All rights reserved.
								<br class="visible-xs visible-sm" />
								Built by <a href="http://www.bubblegate.co.uk" target="_blank">Bubblegate.</a>
								<br />
								<br class="visible-xs visible-sm" />
								Gridiron Building, One Pancras Square,
								<br class="visible-xs visible-sm" />
								London, N1C&nbsp;4AG, United Kingdom
							</small>
						</p>
					</div>
					<div class="hidden-xs col-sm-4">
						<a href="index.html">
							<img
								class="img-responsive logo-foot"
								src="@/assets/images/iadsa-logo.svg"
								alt="IADSA"
							>
						</a>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
export default {
	created() {
		this.getPages();
	},
	data() {
		return {
			pages: []
		};
	},
	computed: {
		currentYear: () => (new Date()).getFullYear(),
	},
	methods: {
		async getPages() {
			const { data: { data: pages } } = await this.$axios.get('/page');
			this.$set(this, 'pages', pages);
		},
	}
};
</script>
